import React, { useState, useEffect } from 'react';
import { getProductColorsDynamic } from '../utils/colorDataDynamic';

function normalize(str) {
  return str
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .replace(/\([^)]*\)/g, '')
    .replace(/\b(5g|4g|ds|con leica|sin stock|stock|gb|tb|m1|m2|gen|inch|wi[-]?fi|usb[-]?c|c\/|c--|c-)/gi, '')
    .replace(/[+\-/().,]/g, '')
    .replace(/\d{1,2}\s*gb/gi, '')
    .replace(/\d{1,2}\s*tb/gi, '')
    .replace(/\s+/g, '')
    .toLowerCase();
}

const FAVORITES_KEY = 'favoriteProducts';

const ProductCard = ({ product, onAddToCart, onProductClick, onRequestColorModal, onFavoritesChange }) => {
  // Estado de favoritos
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    const favs = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    setIsFavorite(favs.includes(product.id));
  }, [product.id]);

  const toggleFavorite = (e) => {
    e.stopPropagation();
    let favs = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    if (favs.includes(product.id)) {
      favs = favs.filter(id => id !== product.id);
      setIsFavorite(false);
    } else {
      favs.push(product.id);
      setIsFavorite(true);
    }
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favs));
    if (onFavoritesChange) onFavoritesChange();
  };

  const handleAddToCartClick = (e) => {
    e.stopPropagation();
    console.log('🛒 handleAddToCartClick llamado para:', product.name);
    console.log('📱 Categoría del producto:', product.category);
    console.log('🔍 Verificando si es celular...');
    
    if (product.category === 'Celulares' || product.category === 'Apple' || product.category === 'IPHONE' || product.category === 'iPhone' || product.category === 'SAMSUNG' || product.category === 'Samsung' || product.category === 'XIAOMI' || product.category === 'Xiaomi' || product.category === 'MOTO' || product.category === 'Motorola') {
      console.log('✅ Es celular, llamando onRequestColorModal');
      onRequestColorModal(product);
    } else {
      console.log('❌ No es celular, agregando directamente al carrito');
      onAddToCart(product);
    }
  };

  const supabaseStorageUrl = "https://xsuruuynxrxrarvalzjb.supabase.co/storage/v1/object/public/images/";

  return (
    <div 
      className="bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden hover:shadow-2xl transition-all duration-200 cursor-pointer relative h-full flex flex-col"
      onClick={onProductClick}
    >
      {/* Botón de favorito */}
      <button
        onClick={toggleFavorite}
        className="group absolute top-0 right-0 -translate-y-[2px] translate-x-[2px] sm:translate-x-[3px] z-20 flex items-center justify-center p-0"
        aria-label={isFavorite ? 'Quitar de favoritos' : 'Agregar a favoritos'}
      >
        {isFavorite ? (
          // Corazón clásico lleno (mantener zoom cuando está en favoritos)
          <svg xmlns="http://www.w3.org/2000/svg" fill="#ef4444" viewBox="0 0 24 24" className="h-4 w-4 sm:h-5 sm:w-5 transition-transform duration-150 scale-125">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c2.04 0 3.81 1.23 4.5 3.09C12.69 4.23 14.46 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
        ) : (
          // Corazón clásico vacío gris
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#9ca3af" viewBox="0 0 24 24" className="h-4 w-4 sm:h-5 sm:w-5 transition-transform duration-150 group-hover:scale-125">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12.1 21.55l-1.1-1.01C5.14 15.24 2 12.39 2 8.5 2 5.5 4.5 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.5 3 22 5.5 22 8.5c0 3.89-3.14 6.74-8.9 12.04l-1 1.01z"/>
          </svg>
        )}
      </button>
      <div className="p-4 flex flex-col h-full">
        <div className="aspect-square bg-white rounded-lg flex items-center justify-center overflow-hidden">
          <img 
            src={product.image ? (supabaseStorageUrl + product.image) : (supabaseStorageUrl + 'blank.jpg')}
            alt={product.name}
            className="w-full h-full object-contain"
            onError={e => {
              if (!e.target.src.includes('blank.jpg')) {
                e.target.onerror = null;
                e.target.src = supabaseStorageUrl + 'blank.jpg';
              }
            }}
          />
        </div>
        <div className="mt-4 flex-1 flex flex-col">
          <h3 className="font-medium text-gray-900 min-h-[2.5rem] leading-tight" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{product.name.replace(/ DS$/, '')}</h3>
          <div className="mt-auto pt-2 flex justify-between items-end">
            <div className="min-h-[3rem] flex flex-col justify-end">
              <span className="text-lg font-semibold text-gray-900">
                {product.pricears && typeof product.pricears === 'number' && !isNaN(product.pricears)
                  ? `$${product.pricears.toLocaleString('es-AR')}`
                  : product.pricears && typeof product.pricears === 'string'
                  ? `$${product.pricears}`
                  : <span className="text-red-500">Sin precio</span>
                }
              </span>
              {product.price && (
                <div className="text-sm font-medium text-green-600 mt-1">
                  USD ${typeof product.price === 'number' ? product.price.toLocaleString('en-US') : product.price}
                </div>
              )}
            </div>
            {/* Botón agregar al carrito */}
            <button
              onClick={handleAddToCartClick}
              className="ml-2 bg-gray-100 text-gray-700 rounded-full transition-all duration-150 hover:bg-gray-200 active:transform active:scale-95 active:shadow-inner flex items-center justify-center shadow-sm hover:shadow-md"
              style={{ boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' }}
              aria-label="Agregar al carrito"
            >
              {/* Versión móvil: solo ícono */}
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 block sm:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              {/* Versión escritorio: texto */}
              <span className="hidden sm:block px-3 py-2 text-sm font-medium">
              Agregar al Carrito
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;